import { n as u } from "./property-4FoNj0Pi.js";
import { r as m, c as h } from "./lit-element-8JrrHldg.js";
var i = /* @__PURE__ */ ((t) => (t[t.element = 1] = "element", t[t.text = 3] = "text", t[t.comment = 8] = "comment", t[t.fragment = 11] = "fragment", t))(i || {}), f = Object.defineProperty, b = Object.getOwnPropertyDescriptor, l = (t, r, e, o) => {
  for (var n = o > 1 ? void 0 : o ? b(r, e) : r, a = t.length - 1, c; a >= 0; a--)
    (c = t[a]) && (n = (o ? c(r, e, n) : c(n)) || n);
  return o && n && f(r, e, n), n;
};
let s = class extends m {
  constructor() {
    super(...arguments), this.observer = new MutationObserver(() => {
      this.dispatchEvent(
        new CustomEvent("p-slotchange", {
          bubbles: !0
        })
      );
    });
  }
  createRenderRoot() {
    return this;
  }
  hasContent() {
    var r;
    if ((r = this.textContent) != null && r.trim())
      return !0;
    const t = Array.from(this.childNodes || []);
    return t.length ? t.some((e) => {
      if (e.nodeType === i.comment || e.nodeType === i.text || !e)
        return !1;
      if (e.nodeValue || e instanceof SVGElement)
        return !0;
      if (e instanceof HTMLElement)
        return e instanceof s ? e.hasContent() : !(e.hidden || e.tagName === "PWC-TEMPLATE" && !e.childElementCount);
    }) : !1;
  }
  connectedCallback() {
    super.connectedCallback(), this.host.slotConnected(this, this.name), this.observer.observe(this, {
      childList: !0,
      characterData: !0,
      subtree: !0
    }), this.dispatchEvent(new CustomEvent("p-slotconnected", { bubbles: !0 }));
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.observer.disconnect();
  }
};
l([
  u()
], s.prototype, "name", 2);
l([
  u({ attribute: !1 })
], s.prototype, "host", 2);
s = l([
  h("p-slot")
], s);
export {
  i as N,
  s as P
};
